import pull from 'lodash/pull';
import * as ResourceApi from 'api/resources';
import ReducerBuilder from 'classes/ReducerBuilder';
import {Types as ResourceActionTypes} from 'resources/actions';
import {Types as SearchActionTypes} from 'components/MasterSearchBar/actions';
import {Types as WinnerActionTypes} from './actions';
import initialState from './initialState';

export default ReducerBuilder.make(initialState)

   /* list winners */

  .forType(WinnerActionTypes.REQUEST_WINNERS)
  .reduce((state, action) => {
    state.currentPrizeType = null;
    state.defaultSort = action.defaultSort;
  })
  .forType(WinnerActionTypes.REQUESTED_WINNERS)
  .reduce((state, action) => {
    state.fetchingWinners = true;
    state.currentPrizeType = action.prizeType;
  })
  .forType(WinnerActionTypes.RECEIVED_WINNERS)
  .reduce((state, action) => {
    state.fetchingWinners = false;
  })
  .forType(WinnerActionTypes.EXPAND_ROW)
  .reduce((state, action) => {
    state.currentExpandedRow = action.row;
  })
  .forType(WinnerActionTypes.COLLAPSE_ROW)
  .reduce((state, action) => {
    state.currentExpandedRow = null;
  })

  // for rendering MasterSearchBar results in the table below
  .forType(SearchActionTypes.SEARCH_QUERY_CHANGED)
  .reduce((state, action) => {
    state.searchResults = null;
  })
  .forType(SearchActionTypes.CLEAR_SEARCH_RESULTS)
  .reduce((state, action) => {
    state.searchResults = null;
  })
  .forType(SearchActionTypes.RECEIVED_SEARCH_RESULTS)
  .reduce((state, action) => {
    if (action.resourceType === ResourceApi.Types.Winner) {
      state.searchResults = action.searchResults;
    }
  })


  /* edit winner story */

  .forType(WinnerActionTypes.OPEN_EDIT_WINNER_STORY_MODAL)
  .reduce((state, action) => {
    state.isEditWinnerStoryModalOpen = true;
    state.currentWinnerId = action.winnerId;
  })
  .forType(ResourceActionTypes.RECEIVED_RESOURCE)
  .reduce((state, action) => {
    if (action.resourceType === ResourceApi.Types.PrizeEntry && action.resource.winner === true) {
      state.currentWinnerId = action.resource.id;
    }
  })
  .forType(WinnerActionTypes.EDIT_WINNER_STORY_ERROR)
  .reduce((state, action) => {
    state.winnerStorySaveError = true;
    state.savingWinnerStory = false;
  })
  .forType(WinnerActionTypes.SAVE_WINNER_STORY)
  .reduce((state, action) => {
    state.savingWinnerStory = true;
  })
  .forType(WinnerActionTypes.CLOSE_EDIT_WINNER_STORY_MODAL)
  .reduce((state, action) => {
    state.isEditWinnerStoryModalOpen = null;
    state.currentWinnerId = null;
    state.winnerStorySaveError = false;
    state.savingWinnerStory = false;
  })

  /* date ordered input */

  .forType(WinnerActionTypes.SUBMIT_SAVE_DATE_ORDERED)
  .reduce((state, action) => {
    state.dateOrderedPendingSaves.push(action.winnerId);
    pull(state.dateOrderedSaveSuccesses, action.winnerId);
    pull(state.dateOrderedSaveErrors, action.winnerId);
  })
  .forType(WinnerActionTypes.SAVE_DATE_ORDERED_SUCCESS)
  .reduce((state, action) => {
    state.dateOrderedSaveSuccesses.push(action.winnerId);
    pull(state.dateOrderedPendingSaves, action.winnerId);
  })
  .forType(WinnerActionTypes.SAVE_DATE_ORDERED_ERROR)
  .reduce((state, action) => {
    state.dateOrderedSaveErrors.push(action.winnerId);
    pull(state.dateOrderedPendingSaves, action.winnerId);
  })

    .forType(WinnerActionTypes.START_EDIT_NOTES)
    .reduce((state, {winnerId}) => {
      state.editingWinnerNotes = winnerId;
    })
    .forType(WinnerActionTypes.END_EDIT_NOTES)
    .reduce((state) => {
      state.editingWinnerNotes = null;
    })
    .forType(WinnerActionTypes.SAVE_NOTES)
    .reduce((state) => {
      state.savingNotes = true;
    })
    .forType(WinnerActionTypes.SUBMIT_SAVE_NOTES)
    .reduce((state) => {
      state.savingNotes = true;
    })
    .forType(WinnerActionTypes.SAVE_NOTES_SUCCESS)
    .reduce((state) => {
      state.editingWinnerNotes = null;
      state.savingNotes = false;
    })
    .forType(WinnerActionTypes.SAVE_NOTES_ERROR)
    .reduce((state) => {
      state.savingNotes = false;
    })

  /* toggle featured winner */

  .forType(WinnerActionTypes.SUBMIT_TOGGLE_FEATURED_WINNER)
  .reduce((state, action) => {
    state.currentWinnerId = action.winnerId;

    state.featuredWinnerPendingSaves.push(action.winnerId);
    pull(state.featuredWinnerSaveSuccesses, action.winnerId);
    pull(state.featuredWinnerSaveErrors, action.winnerId);
  })
  .forType(WinnerActionTypes.TOGGLE_FEATURED_WINNER_SUCCESS)
  .reduce((state, action) => {
    state.featuredWinnerSaveSuccesses.push(action.winnerId);
    pull(state.featuredWinnerPendingSaves, action.winnerId);
  })
  .forType(WinnerActionTypes.TOGGLE_FEATURED_WINNER_ERROR)
  .reduce((state, action) => {
    state.featuredWinnerSaveErrors.push(action.winnerId);
    pull(state.featuredWinnerPendingSaves, action.winnerId);
  })
  .forType(WinnerActionTypes.OPEN_FEATURED_ERROR_MODAL)
  .reduce((state, action) => {
    state.isFeaturedErrorModalOpen = true;
    state.featuredErrorModalLang = action.lang;
  })
  .forType(WinnerActionTypes.CLOSE_FEATURED_ERROR_MODAL)
  .reduce((state, action) => {
    state.isFeaturedErrorModalOpen = false;
    state.featuredErrorModalLang = null;
  })


  /* publish featured winners */

  .forType(WinnerActionTypes.SUBMIT_PUBLISH_FEATURED_WINNERS)
  .reduce((state, action) => {
    state.publishingFeaturedWinners = true;
  })
  .forType(WinnerActionTypes.PUBLISH_FEATURED_WINNERS_SUCCESS)
  .reduce((state, action) => {
    state.publishingFeaturedWinners = false;
  })
  .forType(WinnerActionTypes.PUBLISH_FEATURED_WINNERS_ERROR)
  .reduce((state, action) => {
    state.publishingFeaturedWinners = false;
  })
  .forType(WinnerActionTypes.OPEN_PUBLISH_FEATURED_ERROR_MODAL)
  .reduce((state, action) => {
    state.isPublishFeaturedModalOpen = true;
  })
  .forType(WinnerActionTypes.CLOSE_PUBLISH_FEATURED_ERROR_MODAL)
  .reduce((state, action) => {
    state.isPublishFeaturedModalOpen = false;
  })

  .build();



// WEBPACK FOOTER //
// ./public/pages/ListWinners/reducer.js